import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlocHtmlComponent } from './bloc-html.component';
import { ComponentsModule } from '../../../components/components.module';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { RouterModule } from '@angular/router';
import { BlocEditHtmlComponent } from './bloc-edit-html/bloc-edit-html.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { HtmlWebEditorComponent } from './bloc-edit-html/html-web-editor/html-web-editor.component';
import { InputTextModule } from 'primeng/inputtext';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { ComponentsModule as MarketingComponentsModule} from '../components/components.module';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../../../pipes/pipes.module';
import { MenuModule } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';



@NgModule({
	declarations: [BlocHtmlComponent, BlocEditHtmlComponent, HtmlWebEditorComponent],
	imports: [
		CommonModule,
		ComponentsModule,
		ButtonModule,
		ToastModule,
		ConfirmDialogModule,
		TableModule,
		TagModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		CheckboxModule,
		InputTextModule,
		MonacoEditorModule,
		DropdownModule,
		DialogModule,
		MarketingComponentsModule,
		SelectButtonModule,
		TranslateModule,
		PipesModule,
		MenuModule,
		TooltipModule
	]
})
export class BlocHtmlModule { }
